Vietnam.f = (function(){
    
    Vietnam.state = {
        /* There are three states, null/true/false.
            null is for when the user has not played any media, 
            while false means autoplay has been stopped for some reason by either the user or system  */
        autoplay : null
    }
    
    function init(){
        var startingLat =  16.000;
        var startingLng = 105.758;
        
    	//check Safari/iOS
    	//document.getElementById('map').style.height = document.getElementById('content').clientHeight + 'px';
        
    	// Create a map object and specify the DOM element for display.
    	Vietnam.map = new google.maps.Map(document.getElementById('map'), {
    		 center: {lat: startingLat, lng: startingLng}
            ,mapTypeId: 'terrain'
    		,scrollwheel: false
    		,disableDefaultUI: true
    		,zoom: 6
    		,disableDoubleClickZoom: true 
    		,backgroundColor:'none'
    		/* settings figured out from https://mapstyle.withgoogle.com/, click 'more options' at the btottom */
    		,styles: [
    			{	/* removes both the national border and city text labels */
    				/* featureType:label is the one that just removes city text labels, but leaves the border */
    				"featureType": "administrative", 
    				"stylers": [{"visibility": "off"}]
    			},
    			{
    				"featureType": "poi",
    				"stylers": [{"visibility": "off"}]
    			},
    			{
    				"featureType": "poi", /* points of interest */
    				"elementType": "labels.text",
    				"stylers": [{"visibility": "off"}]
    			},
    			{
    				"featureType": "poi.park", /* adds the green back to the map, which is nice looking */
    				"stylers": [{"visibility": "on"}]
    			},
    			{
    				"featureType": "road",
    				"stylers": [{"visibility": "off"}]
    			},
    			{
    				"featureType": "transit",
    				"stylers": [{"visibility": "off"}]
    			}
    		] //end styles array
    	});
        
    	/* 
        	Wait until the map is loaded, or getBounds() may return undefined.
    	*/
    	google.maps.event.addListenerOnce(Vietnam.map, 'tilesloaded', function() {
        	/* We want Vietnam to be on the right portion of the page, but you only set Center when
            	creating a map. So take the center lng that we set, do some math with the edge of 
            	whatever map loaded, and move the map to get Vietnam to appear where we want. */
        	var newCenter = startingLng - ((Vietnam.map.getBounds().getNorthEast().lng()-startingLng)/2)
            Vietnam.map.setCenter({lat:startingLat,lng:newCenter})
            
            
            // loads the polygon mask that outlines the country
            _loadMask()
    		
            _loadMarkers()
            
            /* The page starts with an intro slide. Bind to the button in that to show the first soldier. */
            document.getElementById('btnStart').addEventListener('click', function(){
                _loadSoldier(0)
            })
            
            /* Tell the map to resize when the window resizes */
            google.maps.event.addDomListenerOnce(Vietnam.map, 'idle', function () {
    		    google.maps.event.addDomListener(window, 'resize', function () {
    		        Vietnam.map.setCenter({lat: startingLat, lng: startingLng});
    		        //and reset offcenter like we did above
    		        var newCenter = startingLng - ((Vietnam.map.getBounds().getNorthEast().lng()-startingLng)/2)
                    Vietnam.map.setCenter({lat:startingLat,lng:newCenter})
    		    });
    		});
    		
    		//preload the first soldier to prevent content flash 
    		var preloaded_image = new Image();
                preloaded_image.src = Vietnam.theDead[0].img;
    	});
    }
    
    /* 
        The final slide. Loads 200+ markers for visual impact.
    */
    function loadUnknownMarkers(i){
        /* These are random marker placements that have been shuffled for a better visual when they are dropped onto the page */    
        var markers = [{"lat":"21.14631236947386","lng":"105.9521484375"},{"lat":"21.412481855424055","lng":"106.0400390625"},{"lat":"20.36554939988006","lng":"106.14990234375"},{"lat":"15.559709791757887","lng":"107.962646484375"},{"lat":"21.310165990100742","lng":"107.2705078125"},{"lat":"20.15942056086951","lng":"106.32568359375"},{"lat":"22.51287411375124","lng":"103.42529296875"},{"lat":"16.952052639788864","lng":"106.76513671875"},{"lat":"12.83356077009499","lng":"109.2919921875"},{"lat":"13.539367559775119","lng":"108.621826171875"},{"lat":"23.01939217250342","lng":"105.13916015625"},{"lat":"20.75643491463538","lng":"104.96337890625"},{"lat":"14.96617908998577","lng":"108.45703125"},{"lat":"9.655077084081547","lng":"106.468505859375"},{"lat":"22.350393337330683","lng":"105.66650390625"},{"lat":"11.512490617697276","lng":"107.896728515625"},{"lat":"14.03034762881775","lng":"108.80859375"},{"lat":"8.917803282726014","lng":"105.260009765625"},{"lat":"13.60361182400159","lng":"108.8525390625"},{"lat":"13.240279696108246","lng":"109.248046875"},{"lat":"22.5737552844127","lng":"102.65625"},{"lat":"10.088022826650995","lng":"106.58935546875"},{"lat":"13.539534450502352","lng":"109.09423828125"},{"lat":"22.289414088696713","lng":"105.53466796875"},{"lat":"17.89544101645658","lng":"105.9521484375"},{"lat":"12.458200339066996","lng":"108.753662109375"},{"lat":"13.229418064683633","lng":"107.90771484375"},{"lat":"9.026322314771733","lng":"104.996337890625"},{"lat":"15.326902913618026","lng":"108.08349609375"},{"lat":"14.541216060718606","lng":"108.380126953125"},{"lat":"22.14702577261191","lng":"103.4912109375"},{"lat":"11.383277500998414","lng":"106.67724609375"},{"lat":"12.501107345993077","lng":"108.25927734375"},{"lat":"13.37909866103748","lng":"108.12744140625"},{"lat":"10.001479413366091","lng":"106.094970703125"},{"lat":"15.602205549076889","lng":"107.841796875"},{"lat":"17.87453019084518","lng":"105.732421875"},{"lat":"10.228606199375891","lng":"106.5673828125"},{"lat":"20.8591326121399","lng":"103.5791015625"},{"lat":"19.704980797886993","lng":"105.18310546875"},{"lat":"11.641644409373049","lng":"107.435302734375"},{"lat":"11.88902106200725","lng":"108.555908203125"},{"lat":"10.898210725172095","lng":"107.874755859375"},{"lat":"13.026300414486977","lng":"109.2919921875"},{"lat":"21.92298170559068","lng":"102.8759765625"},{"lat":"12.22208550280304","lng":"108.665771484375"},{"lat":"10.217794292168712","lng":"105.029296875"},{"lat":"14.222121428748526","lng":"108.78662109375"},{"lat":"12.565454493805206","lng":"108.6767578125"},{"lat":"20.63310555141563","lng":"105.84228515625"},{"lat":"18.47993467536084","lng":"105.22705078125"},{"lat":"10.811892757424635","lng":"106.9189453125"},{"lat":"20.9207176036606","lng":"106.58935546875"},{"lat":"10.660776652116342","lng":"106.58935546875"},{"lat":"13.667671860636283","lng":"108.87451171875"},{"lat":"21.473837024645615","lng":"106.58935546875"},{"lat":"20.262519201041687","lng":"106.23779296875"},{"lat":"10.962932785063916","lng":"106.754150390625"},{"lat":"10.941360334412948","lng":"107.40234375"},{"lat":"10.509585482547392","lng":"107.303466796875"},{"lat":"10.57439082451179","lng":"106.666259765625"},{"lat":"10.585190386924735","lng":"106.01806640625"},{"lat":"14.115433889478153","lng":"108.204345703125"},{"lat":"20.715336272578536","lng":"105.18310546875"},{"lat":"20.550830368616104","lng":"104.91943359375"},{"lat":"21.12581788540358","lng":"104.65576171875"},{"lat":"13.667505060204652","lng":"108.193359375"},{"lat":"12.340169529479203","lng":"108.446044921875"},{"lat":"13.902409118327954","lng":"109.13818359375"},{"lat":"9.936556710293965","lng":"106.34765625"},{"lat":"14.232604388964596","lng":"107.633056640625"},{"lat":"10.444766539850422","lng":"104.688720703125"},{"lat":"21.064317444678004","lng":"104.21630859375"},{"lat":"11.630883874638307","lng":"108.138427734375"},{"lat":"18.75063491489063","lng":"105.1611328125"},{"lat":"11.899771504288491","lng":"109.061279296875"},{"lat":"11.673923514046047","lng":"107.46826171875"},{"lat":"14.615644340675722","lng":"108.292236328125"},{"lat":"12.157653774191079","lng":"108.819580078125"},{"lat":"9.936556710293965","lng":"106.094970703125"},{"lat":"9.123961546558927","lng":"105.35888671875"},{"lat":"11.512490617697276","lng":"106.644287109375"},{"lat":"14.605179384057834","lng":"108.78662109375"},{"lat":"20.941240316151884","lng":"103.1396484375"},{"lat":"20.8591326121399","lng":"106.171875"},{"lat":"12.318703650757806","lng":"108.43505859375"},{"lat":"11.942769019327992","lng":"107.193603515625"},{"lat":"10.509585482547392","lng":"106.776123046875"},{"lat":"22.024863869070725","lng":"106.10595703125"},{"lat":"16.931033540820618","lng":"107.1826171875"},{"lat":"19.456557313415125","lng":"104.0625"},{"lat":"10.725549947941222","lng":"105.347900390625"},{"lat":"9.925735004399138","lng":"106.556396484375"},{"lat":"9.763366703713771","lng":"106.336669921875"},{"lat":"14.45612445767786","lng":"108.643798828125"},{"lat":"12.769113855469312","lng":"107.918701171875"},{"lat":"21.14631236947386","lng":"107.02880859375"},{"lat":"17.999958134633985","lng":"106.10595703125"},{"lat":"9.622583389107684","lng":"105.347900390625"},{"lat":"21.473837024645615","lng":"105.49072265625"},{"lat":"22.269081755237067","lng":"102.6123046875"},{"lat":"19.269989384555554","lng":"105.00732421875"},{"lat":"19.829048354783524","lng":"105.7763671875"},{"lat":"22.5737552844127","lng":"105.93017578125"},{"lat":"10.06638914559912","lng":"105.457763671875"},{"lat":"21.310165990100742","lng":"103.24951171875"},{"lat":"10.725549947941222","lng":"105.699462890625"},{"lat":"12.49038126113956","lng":"107.81982421875"},{"lat":"11.09250280244198","lng":"108.3251953125"},{"lat":"16.636520830039217","lng":"106.787109375"},{"lat":"22.756237279975558","lng":"106.5234375"},{"lat":"20.653667405666592","lng":"106.45751953125"},{"lat":"10.26103971068643","lng":"104.8095703125"},{"lat":"21.45338816921794","lng":"105.44677734375"},{"lat":"10.131285826293677","lng":"105.347900390625"},{"lat":"15.411650355588346","lng":"107.6220703125"},{"lat":"10.293469898711777","lng":"104.65576171875"},{"lat":"14.77521447714538","lng":"108.5009765625"},{"lat":"19.062442379865512","lng":"105.18310546875"},{"lat":"13.518004580707641","lng":"108.45703125"},{"lat":"21.86181736729277","lng":"104.08447265625"},{"lat":"9.839148512095806","lng":"105.347900390625"},{"lat":"11.458658992577961","lng":"106.32568359375"},{"lat":"11.426355092695756","lng":"108.863525390625"},{"lat":"18.729827140879586","lng":"105.64453125"},{"lat":"15.242121102078487","lng":"107.77587890625"},{"lat":"9.026322314771733","lng":"104.8974609375"},{"lat":"17.9372552731795","lng":"105.6884765625"},{"lat":"19.311467361010138","lng":"104.4580078125"},{"lat":"14.605179384057834","lng":"108.4130859375"},{"lat":"11.598599775991106","lng":"108.643798828125"},{"lat":"10.06638914559912","lng":"105.1611328125"},{"lat":"9.730883497399883","lng":"105.1611328125"},{"lat":"18.146178019606154","lng":"105.84228515625"},{"lat":"10.433962066065368","lng":"106.907958984375"},{"lat":"13.560895496663738","lng":"109.16015625"},{"lat":"20.776980048102505","lng":"104.69970703125"},{"lat":"17.14111846656429","lng":"106.611328125"},{"lat":"14.721926704922804","lng":"107.918701171875"},{"lat":"21.084820420772715","lng":"107.16064453125"},{"lat":"16.74175631755664","lng":"106.67724609375"},{"lat":"13.59276661046418","lng":"108.80859375"},{"lat":"12.89765651422799","lng":"107.589111328125"},{"lat":"12.983314989797897","lng":"107.6220703125"},{"lat":"19.95301911190779","lng":"105.44677734375"},{"lat":"12.157653774191079","lng":"107.6220703125"},{"lat":"15.581041445584825","lng":"107.73193359375"},{"lat":"14.860182241022713","lng":"108.28125"},{"lat":"12.060976930505321","lng":"107.40234375"},{"lat":"15.157305092742282","lng":"108.43505859375"},{"lat":"9.698397132658066","lng":"105.985107421875"},{"lat":"15.199551705037425","lng":"107.874755859375"},{"lat":"21.514726121552133","lng":"105.31494140625"},{"lat":"11.867518903750625","lng":"108.83056640625"},{"lat":"15.273752700271801","lng":"107.764892578125"},{"lat":"12.211347968927269","lng":"108.45703125"},{"lat":"8.733247092376189","lng":"105.062255859375"},{"lat":"19.14549252968616","lng":"105.31494140625"},{"lat":"12.994020227627564","lng":"107.666015625"},{"lat":"22.553464544896258","lng":"103.6669921875"},{"lat":"20.32434555172895","lng":"106.32568359375"},{"lat":"10.790478002761684","lng":"107.7978515625"},{"lat":"12.071720528683754","lng":"107.896728515625"},{"lat":"11.631052011193582","lng":"107.2705078125"},{"lat":"21.800626820243462","lng":"106.06201171875"},{"lat":"12.082463696038444","lng":"108.25927734375"},{"lat":"22.330069881871495","lng":"104.677734375"},{"lat":"13.068943949534367","lng":"108.116455078125"},{"lat":"10.930573520043014","lng":"106.89697265625"},{"lat":"19.663603522026257","lng":"105.8642578125"},{"lat":"19.56011364667666","lng":"105.05126953125"},{"lat":"17.225086131231663","lng":"106.5673828125"},{"lat":"11.79224801406379","lng":"108.45703125"},{"lat":"11.88902106200725","lng":"106.875"},{"lat":"21.514726121552133","lng":"107.666015625"},{"lat":"21.412481855424055","lng":"104.08447265625"},{"lat":"13.667505060204652","lng":"107.764892578125"},{"lat":"14.26471582511687","lng":"108.96240234375"},{"lat":"14.009029482383632","lng":"109.0283203125"},{"lat":"14.838777489967061","lng":"108.30322265625"},{"lat":"10.347512799720427","lng":"106.34765625"},{"lat":"11.20012526171062","lng":"108.380126953125"},{"lat":"15.411650355588346","lng":"107.75390625"},{"lat":"15.602205549076889","lng":"108.0615234375"},{"lat":"20.46851086988426","lng":"106.171875"},{"lat":"9.297476262601492","lng":"104.96337890625"},{"lat":"10.660776652116342","lng":"107.29248046875"},{"lat":"9.882444607731806","lng":"105.479736328125"},{"lat":"9.340841567215806","lng":"105.875244140625"},{"lat":"22.289414088696713","lng":"104.2822265625"},{"lat":"12.972609290782916","lng":"107.9736328125"},{"lat":"13.02613317046673","lng":"108.292236328125"},{"lat":"14.902653601205364","lng":"108.17138671875"},{"lat":"18.79224276575575","lng":"104.91943359375"},{"lat":"13.176105509107648","lng":"109.248046875"},{"lat":"11.383277500998414","lng":"106.3916015625"},{"lat":"9.5467526337689","lng":"105.150146484375"},{"lat":"17.958158699305386","lng":"106.36962890625"},{"lat":"9.373362004477064","lng":"105.633544921875"},{"lat":"13.763562511938263","lng":"107.633056640625"},{"lat":"15.475188278913231","lng":"108.39111328125"},{"lat":"12.929781889949297","lng":"108.34716796875"},{"lat":"14.349880448630426","lng":"108.9404296875"},{"lat":"21.61689851322718","lng":"107.24853515625"},{"lat":"11.07093984775228","lng":"108.30322265625"},{"lat":"18.64657044432804","lng":"105.62255859375"},{"lat":"13.293578211243968","lng":"108.468017578125"},{"lat":"21.228261932100718","lng":"106.36962890625"},{"lat":"17.120120611095256","lng":"106.611328125"},{"lat":"11.68468238121565","lng":"106.094970703125"},{"lat":"17.89544101645658","lng":"106.01806640625"},{"lat":"10.088022826650995","lng":"106.226806640625"},{"lat":"13.550048330266899","lng":"107.940673828125"},{"lat":"18.27141212303161","lng":"105.75439453125"},{"lat":"11.286329110485406","lng":"106.10595703125"},{"lat":"12.340169529479203","lng":"107.75390625"},{"lat":"10.48798067555274","lng":"106.89697265625"},{"lat":"9.373362004477064","lng":"105.985107421875"},{"lat":"21.657747283603534","lng":"103.623046875"},{"lat":"10.347512799720427","lng":"105.743408203125"},{"lat":"14.902653601205364","lng":"107.77587890625"},{"lat":"15.093670746976166","lng":"107.9736328125"},{"lat":"11.092334348020543","lng":"106.204833984375"},{"lat":"11.68468238121565","lng":"107.523193359375"},{"lat":"13.795572912603431","lng":"107.99560546875"},{"lat":"20.303739509661277","lng":"104.765625"},{"lat":"22.897999479591427","lng":"105.380859375"},{"lat":"22.167375804496256","lng":"104.8974609375"},{"lat":"20.44792408795391","lng":"104.69970703125"},{"lat":"13.485956522143459","lng":"108.21533203125"},{"lat":"22.533170820640027","lng":"106.45751953125"},{"lat":"19.103972666654478","lng":"105.62255859375"},{"lat":"22.30974346495114","lng":"105.27099609375"},{"lat":"12.179132755718605","lng":"108.072509765625"},{"lat":"18.313136781376755","lng":"105.93017578125"},{"lat":"11.232454725466887","lng":"108.52294921875"},{"lat":"20.262519201041687","lng":"106.3916015625"},{"lat":"20.961760215887473","lng":"105.380859375"},{"lat":"13.774399857345585","lng":"108.78662109375"},{"lat":"20.715336272578536","lng":"104.83154296875"},{"lat":"12.886947138478071","lng":"108.65478515625"},{"lat":"10.725549947941222","lng":"107.24853515625"},{"lat":"14.562649995086455","lng":"108.83056640625"},{"lat":"9.633414968446509","lng":"105.787353515625"},{"lat":"21.043811642377296","lng":"103.5791015625"},{"lat":"9.275791593550109","lng":"105.084228515625"},{"lat":"12.479654731462343","lng":"108.094482421875"},{"lat":"20.9822773006213","lng":"105.5126953125"},{"lat":"21.084820420772715","lng":"104.96337890625"},{"lat":"22.22840822522651","lng":"104.65576171875"},{"lat":"21.14631236947386","lng":"105.6884765625"},{"lat":"8.70066881523288","lng":"104.864501953125"},{"lat":"9.828323600532281","lng":"105.64453125"},{"lat":"11.759982732693897","lng":"107.6220703125"},{"lat":"18.500773038403693","lng":"105.53466796875"},{"lat":"15.030017334529468","lng":"108.193359375"},{"lat":"10.05557176107211","lng":"106.094970703125"},{"lat":"12.66194499707541","lng":"108.193359375"},{"lat":"13.75289140431433","lng":"107.720947265625"},{"lat":"20.46851086988426","lng":"104.96337890625"},{"lat":"10.90899871505442","lng":"106.36962890625"},{"lat":"12.436744171668114","lng":"108.709716796875"},{"lat":"21.269219658065087","lng":"106.54541015625"},{"lat":"14.753967334615279","lng":"108.80859375"},{"lat":"9.741711584274768","lng":"105.413818359375"},{"lat":"13.27219337762855","lng":"107.720947265625"},{"lat":"12.060976930505321","lng":"108.1494140625"},{"lat":"10.811892757424635","lng":"106.666259765625"},{"lat":"21.82102657772957","lng":"106.611328125"},{"lat":"19.33220240565457","lng":"105.57861328125"},{"lat":"19.373664595868803","lng":"105.46875"},{"lat":"19.103972666654478","lng":"104.47998046875"},{"lat":"12.994020227627564","lng":"108.358154296875"},{"lat":"15.32673735758499","lng":"108.160400390625"},{"lat":"21.02330301610793","lng":"106.962890625"}]
        var s = new google.maps.Size(32, 32)
        i = i || 0;

        for(l=markers.length;i<l;i++){
            markers[i] = new google.maps.Marker({
        		 position: new google.maps.LatLng(markers[i].lat, markers[i].lng) 
        		,icon:{
            		 url:"/assets/imgs/pin.svg"
            		,scaledSize: s
                }
        		,map:Vietnam.map
        		,animation:google.maps.Animation.DROP
        	})
        	/* If we let them all fire at once, the visual is jumpy because the browser can't handle it. 
            	To get around that, every now and then throw in a delay. Play with the modulus and the delay
            	to adjust the resulting look.
        	*/
        	if(i%5===0){ 
            	/* This bind just gets us a way to pass in a var without having to wrap a function around it */
            	setTimeout(Vietnam.f.loadUnknownMarkers.bind(null,++i), 100)
                break; 
            }
    	}
    }

    
    
    /* 
        Private Functions  
    */
    
    /* Load a single slide with a soldier's info. 
        int i = the position the soldier's info exists at in Vietnam.theDead[]
        int triggeredBy = the slide we are coming from as a position in Vietnam.theDead[]. Just used to shrink the previous map marker without having to loop all of them.
    */
    function _loadSoldier(i,triggeredBy){
        Vietnam.state.current = i;
        
        var  s = document.getElementById('slider')
            ,d = Vietnam.theDead[i] //soldier's info
            ,h = ""; //html
        /*
             'name':"Lorenzo R Johnson"
            ,'lat':11.325402
            ,'lng':106.477017
            ,'img': "/assets/imgs/s/LorenzoJohnson.jpg"
            ,'imgalt':""
            ,'audio':"https://ondemand.npr.org/anon.npr-mp3/npr/atc/2010/11/20101111_atc_agentorange.mp3"
            ,'quote':"You told her you were not coming back and you had seen it in a vision, that you made peace with it."
            ,'infoWindowContent':"Lorenzo Johnson died to an explosive device during combat in the Bing Duong province.<br><br>He was 20 years old."
        */
        h += '<div class="soldierContent row">'
        h +=    '<img src="'+d.imgname+'" style="left: calc(50% - 406px);position: relative;" />'
        h +=    '<div class="col-lg-5 no-side-padding">'
        h +=        '<img src="'+d.img+'" style="max-width:100%">'
        h +=    '</div>'
        h +=    '<div class="col-lg-7 no-side-padding">'
        h +=    '<div class="details">'
        h +=        "<p class='quote'>"+d.quote+"</p>";
        h +=        "<div class='row'>"
        h +=            '<div class="col-4 no-side-padding">'
        h +=                '<img src="'+d.img+'" style="max-width:90%;margin-top:1.3rem">'
        h +=            '</div>'
        h +=            '<div class="col-8 col-lg-12 no-side-padding">'
        h +=                "<p style='margin-bottom:.5rem'>"+d.infoWindowContent+"</p>";
        h +=            '</div>'
        h +=        '</div>'
        h +=        '<div id="player"></div>'
        h +=    '</div>'
        h +=    '</div>'
        h += '</div>'
        
        h += '<div class="sliderFooter">'
            if(i>0){
                h += "<button id='btnPrev'><span>PREV</span></button>";
            }
            h += "<span class='soldierCount'";
            if(i===0){ h += " style='margin-left:90px' " }
            h += ">"+(i+1)+"/"+Vietnam.theDead.length+"</span>"
            if((i+1)<=Vietnam.theDead.length){
                h += "<button id='btnNext'><span>NEXT</span></button>";
            }
        h += '</div>'
        
        s.innerHTML = h;
        
        //shrink the old marker 
        if(typeof triggeredBy != 'undefined'){
            Vietnam.markers[triggeredBy].setIcon({
        		 url:"/assets/imgs/pin.svg" 
        		,scaledSize: new google.maps.Size(32, 32)
            })
        }
        //increase size of current marker
        Vietnam.markers[i].setIcon({
    		url:"/assets/imgs/pin.svg"
    		,scaledSize: new google.maps.Size(96, 96)
        })
        
        if(i>0){
            document.getElementById('btnPrev').addEventListener('click', function(){
                Vietnam.state.autoplay = null;
                _loadSoldier(i-1,i)
            })    
        }
        if((i+1)<Vietnam.theDead.length){
            document.getElementById('btnNext').addEventListener('click', function(){
                Vietnam.state.autoplay = null;
                _loadSoldier(i+1,i)
            })
        }
        if((i+1)==Vietnam.theDead.length){
            document.getElementById('btnNext').addEventListener('click', function(){
                Vietnam.state.autoplay = null;
                _loadFinalSlide(i)
            })
        }
        
        //setup the audio player now that the container is on the page
        var playerInstance = jwplayer("player");
            var playerOpts = {
                file: d.audio
                ,height:30
                ,width: 300
            }
            if(Vietnam.state.autoplay){
                playerOpts.autostart = true;
            }
            
            playerInstance.setup(playerOpts);
            
            playerInstance.on('play',function(){
                //First time any media has been played, turn on autoplay. 
                //  Otherwise, let the toggle button handle it
                if(Vietnam.state.autoplay === null){ 
                    Vietnam.state.autoplay = true;
                }
            })
            
            playerInstance.on('complete',function(){
                if(Vietnam.state.autoplay){
                    /* We want to show a 5 second countdown bar before moving on to the next item */
                    var seconds = 5;
                    var playerDiv = document.getElementById('player')
                    var countDownDiv = document.createElement('div')
                    countDownDiv.className = 'countDown'
                    countDownDiv.innerHTML = "Continuing to next in <span>"+seconds+"</span> <span>cancel</span>";
                    playerDiv.appendChild(countDownDiv)
                    
                    var countDownSpan = playerDiv.getElementsByClassName('countDown')[0].getElementsByTagName('span')[0];
                    var cancelSpan = playerDiv.getElementsByClassName('countDown')[0].getElementsByTagName('span')[1];
                    
                    var timer = setInterval(function(){
                        countDownSpan.innerHTML = --seconds;
                        if(seconds === 0){
                            clearInterval(timer)
                            if((i+1)===Vietnam.theDead.length){
                                _loadFinalSlide(i)
                            }else{
                                _loadSoldier(i+1,i)
                            }
                        }
                    },1000)
                    
                    /* Let them cancel the auto-continue */
                    cancelSpan.addEventListener('click', function(){
                        clearInterval(timer)
                        countDownDiv.remove(); //the countdown is on top of the audio player, so removing this reveals the player controls
                        Vietnam.state.autoplay = false;
                    })  
                }
            })
            
            //preload the next soldier's image to prevent flashing
            if((i+1)<Vietnam.theDead.length){
                var preloaded_image = new Image();
                preloaded_image.src = Vietnam.theDead[i+1].img;
            }
    }
    
    function _loadFinalSlide(triggeredBy){
        Vietnam.markers[triggeredBy].setIcon({
    		 url:"/assets/imgs/pin.svg" 
    		,scaledSize: new google.maps.Size(32, 32)
        })
        
        var  s = document.getElementById('slider');
        h="";
        h += '<div class="outroSlide">'
        h += '<h1>There are still over 200 Virginians on the Vietnam Veterans Memorial without a photo.</h1>'
        h += '<p><a class="btn" href="/walloffaces">Help us find them</a></p>'
        h += '<img src="/assets/imgs/miniwall.jpg" />';
        h += '</div>'
        s.innerHTML = h;
        
        loadUnknownMarkers()
    }
    
    
    
    /* Puts the initital map markers on the map. Just loops the Vietnam.theDead array and places everything present */
    function _loadMarkers(){
        Vietnam.markers = [];
    
        for(var i=0,l=Vietnam.theDead.length;i<l;i++){
        	Vietnam.markers[i] = new google.maps.Marker({
        		 position: new google.maps.LatLng(Vietnam.theDead[i].lat, Vietnam.theDead[i].lng) 
        		,icon:{
            		url:"/assets/imgs/pin.svg"
            		,scaledSize: new google.maps.Size(32, 32)
                }
        		,map:Vietnam.map
        		,animation:google.maps.Animation.DROP
        	})
        	
        	Vietnam.markers[i].index = i;
        	Vietnam.markers[i].addListener('click',function(){
            	_loadSoldier(this.index,Vietnam.state.current)
        	})
    	}
    }
        
    
    function _loadMask(){
        /* Vietnam coordinates from https://fusiontables.google.com/data?docid=1N2LBk4JHwWpOY4d9fobIn27lfnZ5MDy-NoqqRpk&pli=1#card:id=2 
    		- then we customized from there using http://maps.vasile.ch/geomask/
    	*/
    	var polygonMask = new google.maps.Polygon({
    		map:Vietnam.map,
    		strokeColor: '#000000',
    		strokeOpacity: 0.5,
    		strokeWeight: 0,
    		fillColor: '#CACACA',
    		fillOpacity: 0.7,
    		paths: [
    			[
    				new google.maps.LatLng(-59.903343, 19.783709),
    				new google.maps.LatLng(90.000000, 19.783709),
    				new google.maps.LatLng(-59.903343, -168.170395),
    				new google.maps.LatLng(-59.903343, 19.783709)
    			],
    			[
    				new google.maps.LatLng(10.461035, 103.995912),
    				new google.maps.LatLng(10.367709, 103.838382),
    				new google.maps.LatLng(9.907159, 104.026382),
    				new google.maps.LatLng(10.319354, 104.101784),
    				new google.maps.LatLng(10.463736, 103.998658),
    				new google.maps.LatLng(10.422736, 104.445327),
    				new google.maps.LatLng(10.133745, 104.612983),
    				new google.maps.LatLng(10.207427, 104.801491),
    				new google.maps.LatLng(10.092602, 104.874826),
    				new google.maps.LatLng(9.956094, 105.071758),
    				new google.maps.LatLng(9.858659, 104.894186),
    				new google.maps.LatLng(9.533745, 104.834718),
    				new google.maps.LatLng(8.803075, 104.782457),
    				new google.maps.LatLng(8.750638, 104.807189),
    				new google.maps.LatLng(8.640302, 104.709795),
    				new google.maps.LatLng(8.588970, 104.702808),
    				new google.maps.LatLng(8.570222, 104.822164),
    				new google.maps.LatLng(8.625064, 105.121300),
    				new google.maps.LatLng(8.831206, 105.322093),
    				new google.maps.LatLng(9.129445, 105.533872),
    				new google.maps.LatLng(9.368473, 106.194545),
    				new google.maps.LatLng(9.473657, 106.224719),
    				new google.maps.LatLng(9.532364, 106.398454),
    				new google.maps.LatLng(9.583609, 106.543027),
    				new google.maps.LatLng(9.741391, 106.570672),
    				new google.maps.LatLng(9.752591, 106.598208),
    				new google.maps.LatLng(9.842218, 106.674409),
    				new google.maps.LatLng(9.884516, 106.700375),
    				new google.maps.LatLng(9.965976, 106.650546),
    				new google.maps.LatLng(10.082364, 106.778027),
    				new google.maps.LatLng(10.187055, 106.814333),
    				new google.maps.LatLng(10.279791, 106.784236),
    				new google.maps.LatLng(10.364344, 106.892932),
    				new google.maps.LatLng(10.405655, 106.982402),
    				new google.maps.LatLng(10.378364, 106.973329),
    				new google.maps.LatLng(10.391625, 106.980007),
    				new google.maps.LatLng(10.390882, 106.978132),
    				new google.maps.LatLng(10.279643, 107.031541),
    				new google.maps.LatLng(10.376127, 107.266191),
    				new google.maps.LatLng(10.704236, 107.999691),
    				new google.maps.LatLng(10.902488, 108.338383),
    				new google.maps.LatLng(11.362254, 109.021682),
    				new google.maps.LatLng(11.721150, 109.270539),
    				new google.maps.LatLng(11.826766, 109.279240),
    				new google.maps.LatLng(11.973117, 109.289217),
    				new google.maps.LatLng(12.195944, 109.352994),
    				new google.maps.LatLng(12.369953, 109.418780),
    				new google.maps.LatLng(12.634207, 109.488474),
    				new google.maps.LatLng(12.900554, 109.464845),
    				new google.maps.LatLng(13.424639, 109.388165),
    				new google.maps.LatLng(13.655320, 109.373762),
    				new google.maps.LatLng(13.864445, 109.304427),
    				new google.maps.LatLng(14.700375, 109.097008),
    				new google.maps.LatLng(15.249691, 108.965832),
    				new google.maps.LatLng(15.435183, 108.895081),
    				new google.maps.LatLng(15.643617, 108.825483),
    				new google.maps.LatLng(15.974734, 108.748018),
    				new google.maps.LatLng(16.150418, 108.330827),
    				new google.maps.LatLng(16.218451, 108.228629),
    				new google.maps.LatLng(16.328361, 108.054000),
    				new google.maps.LatLng(16.625443, 107.759324),
    				new google.maps.LatLng(17.399718, 106.698863),
    				new google.maps.LatLng(17.757359, 106.501895),
    				new google.maps.LatLng(17.956109, 106.509918),
    				new google.maps.LatLng(18.123467, 106.457689),
    				new google.maps.LatLng(18.522604, 105.916568),
    				new google.maps.LatLng(18.925264, 105.775921),
    				new google.maps.LatLng(19.760283, 106.039189),
    				new google.maps.LatLng(20.186010, 106.607278),
    				new google.maps.LatLng(20.573460, 106.657634),
    				new google.maps.LatLng(20.652910, 106.826366),
    				new google.maps.LatLng(20.513177, 107.278368),
    				new google.maps.LatLng(20.663163, 107.530047),
    				new google.maps.LatLng(20.712791, 107.635401),
    				new google.maps.LatLng(20.842883, 107.780648),
    				new google.maps.LatLng(20.948760, 107.862311),
    				new google.maps.LatLng(21.221028, 108.004278),
    				new google.maps.LatLng(21.542409, 107.990018),
    				new google.maps.LatLng(21.655749, 107.856324),
    				new google.maps.LatLng(21.666936, 107.783054),
    				new google.maps.LatLng(21.653775, 107.469844),
    				new google.maps.LatLng(21.959650, 107.007419),
    				new google.maps.LatLng(22.030827, 106.693309),
    				new google.maps.LatLng(22.279571, 106.707653),
    				new google.maps.LatLng(22.456818, 106.551709),
    				new google.maps.LatLng(22.585079, 106.738265),
    				new google.maps.LatLng(22.809462, 106.850663),
    				new google.maps.LatLng(22.866945, 106.702900),
    				new google.maps.LatLng(22.952981, 106.561893),
    				new google.maps.LatLng(23.011147, 106.005245),
    				new google.maps.LatLng(22.945412, 105.882556),
    				new google.maps.LatLng(23.397286, 105.325768),
    				new google.maps.LatLng(23.180273, 104.907491),
    				new google.maps.LatLng(23.125639, 104.808723),
    				new google.maps.LatLng(22.818054, 104.731927),
    				new google.maps.LatLng(22.869254, 104.578033),
    				new google.maps.LatLng(22.687500, 104.374700),
    				new google.maps.LatLng(22.849171, 104.264973),
    				new google.maps.LatLng(22.798127, 104.111300),
    				new google.maps.LatLng(22.739766, 104.034489),
    				new google.maps.LatLng(22.503873, 103.968663),
    				new google.maps.LatLng(22.808194, 103.631837),
    				new google.maps.LatLng(22.716594, 103.557901),
    				new google.maps.LatLng(22.584364, 103.522418),
    				new google.maps.LatLng(22.761677, 103.439032),
    				new google.maps.LatLng(22.837548, 103.333672),
    				new google.maps.LatLng(22.436518, 103.030400),
    				new google.maps.LatLng(22.624581, 102.870521),
    				new google.maps.LatLng(22.751448, 102.598321),
    				new google.maps.LatLng(22.794664, 102.488169),
    				new google.maps.LatLng(22.396282, 102.140745),
    				new google.maps.LatLng(21.928473, 102.604427),
    				new google.maps.LatLng(21.638113, 102.664205),
    				new google.maps.LatLng(21.704312, 102.934840),
    				new google.maps.LatLng(21.427315, 102.867775),
    				new google.maps.LatLng(21.257338, 102.806203),
    				new google.maps.LatLng(20.836181, 103.157901),
    				new google.maps.LatLng(20.654442, 103.720013),
    				new google.maps.LatLng(20.975900, 104.103945),
    				new google.maps.LatLng(20.652354, 104.641891),
    				new google.maps.LatLng(20.446862, 104.340311),
    				new google.maps.LatLng(20.350156, 104.652102),
    				new google.maps.LatLng(20.191534, 104.667262),
    				new google.maps.LatLng(20.183464, 104.939282),
    				new google.maps.LatLng(20.003954, 104.977827),
    				new google.maps.LatLng(19.998949, 104.876945),
    				new google.maps.LatLng(19.877676, 104.771573),
    				new google.maps.LatLng(19.801481, 104.824194),
    				new google.maps.LatLng(19.771780, 104.712020),
    				new google.maps.LatLng(19.639947, 104.625001),
    				new google.maps.LatLng(19.721148, 104.373113),
    				new google.maps.LatLng(19.693736, 104.038827),
    				new google.maps.LatLng(19.478609, 104.103863),
    				new google.maps.LatLng(19.309509, 103.877682),
    				new google.maps.LatLng(18.825343, 104.694729),
    				new google.maps.LatLng(18.621111, 105.121761),
    				new google.maps.LatLng(18.443970, 105.094861),
    				new google.maps.LatLng(18.334445, 105.183318),
    				new google.maps.LatLng(18.139208, 105.382329),
    				new google.maps.LatLng(18.168327, 105.504436),
    				new google.maps.LatLng(17.882952, 105.610142),
    				new google.maps.LatLng(17.670409, 105.754300),
    				new google.maps.LatLng(17.176604, 106.295029),
    				new google.maps.LatLng(16.933887, 106.500676),
    				new google.maps.LatLng(16.602009, 106.565222),
    				new google.maps.LatLng(16.396073, 106.714913),
    				new google.maps.LatLng(16.536873, 106.875118),
    				new google.maps.LatLng(16.413063, 106.865241),
    				new google.maps.LatLng(16.299718, 106.987200),
    				new google.maps.LatLng(16.047646, 107.331126),
    				new google.maps.LatLng(16.080482, 107.460818),
    				new google.maps.LatLng(15.790345, 107.176300),
    				new google.maps.LatLng(15.268178, 107.670535),
    				new google.maps.LatLng(15.023191, 107.468036),
    				new google.maps.LatLng(14.708618, 107.546600),
    				new google.maps.LatLng(14.128400, 107.344082),
    				new google.maps.LatLng(13.538036, 107.629245),
    				new google.maps.LatLng(13.020554, 107.483318),
    				new google.maps.LatLng(12.359300, 107.549909),
    				new google.maps.LatLng(11.972636, 106.419545),
    				new google.maps.LatLng(11.665864, 106.458209),
    				new google.maps.LatLng(11.776245, 106.043372),
    				new google.maps.LatLng(11.661945, 105.853145),
    				new google.maps.LatLng(11.296736, 105.871136),
    				new google.maps.LatLng(11.053682, 106.189400),
    				new google.maps.LatLng(10.770554, 106.203309),
    				new google.maps.LatLng(11.020973, 105.781354),
    				new google.maps.LatLng(10.954300, 105.100800),
    				new google.maps.LatLng(10.713191, 105.094145),
    				new google.maps.LatLng(10.530418, 104.877882),
    				new google.maps.LatLng(10.544094, 104.614913),
    				new google.maps.LatLng(10.422736, 104.445327),
    				new google.maps.LatLng(10.461035, 103.995912)]
    			]
    	});
    
    }
        
    
    return {
        /* This is public 100% bc we need it in a setTimeout. It should not be called outside of this file */
        loadUnknownMarkers:loadUnknownMarkers,
        init:init
    }    
})()



